import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-table-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./header.component.scss']
})
export class TableHeaderComponent {
  readonly headerArray = input<string[]>(undefined);
}
